import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";

const PageNotFound = () => {
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center min-vh-100 text-center">
      <Row>
        <Col>
          <h1
            className="display-1 fw-bold text-primary"
            style={{
              fontSize: "8rem",
              animation: "float 3s ease-in-out infinite",
            }}
          >
            404
          </h1>
          <h2 className="fw-semibold mb-3">¡Ups! Página no encontrada</h2>
          <p className="text-muted fs-5 mb-4">
            La página que estás buscando no existe.
          </p>
          <Link to="/">
            <Button
              variant="primary"
              size="lg"
              style={{
                animation: "pulse 2s ease-in-out infinite",
              }}
            >
              Volver al inicio
            </Button>
          </Link>
        </Col>
      </Row>
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.7);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(13, 110, 253, 0);
          }
        }
      `}</style>
    </Container>
  );
};

export default PageNotFound;
